import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@/components/Navigation/Buttons/HeaderButton/headerButton.container"
    ).then((module) => ({
        default: module.HeaderButton
    }))
);
